import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=e56977b4&scoped=true"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=e56977b4&prod&lang=css"
import style1 from "./Lista.vue?vue&type=style&index=1&id=e56977b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56977b4",
  null
  
)

export default component.exports